/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "bootstrap"; // Import Bootstrap JavaScript

console.log("in application.js");

// Button spinner functionality
window.showSpinner = function (button) {
  const spinner = button.querySelector(".spinner-border");
  const btnIcon = button.querySelector(".btn-icon");

  spinner.classList.remove("d-none");
  btnIcon.classList.add("d-none");
  button.disabled = true;
};

// Reset button states when page loads (handles back button navigation)
function resetSpinnerButtons() {
  const buttonsWithSpinners = document.querySelectorAll(
    'a[onclick*="showSpinner"]'
  );
  buttonsWithSpinners.forEach((button) => {
    const spinner = button.querySelector(".spinner-border");
    const btnIcon = button.querySelector(".btn-icon");

    if (spinner && btnIcon) {
      spinner.classList.add("d-none");
      btnIcon.classList.remove("d-none");
      button.disabled = false;
    }
  });
}

// Reset on both initial load and back button navigation
document.addEventListener("DOMContentLoaded", resetSpinnerButtons);
window.addEventListener("pageshow", resetSpinnerButtons);
